'use client';

import { useEffect } from 'react';
import { addRecentCalculator } from '@/lib/recentCalculators';

interface CalculatorTrackerProps {
  name: string;
  path: string;
}

export default function CalculatorTracker({ name, path }: CalculatorTrackerProps) {
  useEffect(() => {
    addRecentCalculator(name, path);
  }, [name, path]);

  return null;
}